module.exports = "/assets/landing-rc/promo/delice-photo-small.jpg?BH/caf2";